export default __webpack_public_path__ + "static/media/logo-bicolor.33560b94.png";